const AddressValidationMessages = {
  english: {
    custom: {
      buildingName: {
        required: 'Please enter your building name.'
      },
      buildingNumber: {
        required: 'Please enter your building number.'
      },
      street: {
        required: 'Please enter your street name.'
      },
      town: {
        required: 'Please enter your town/city.'
      },
      postcode: {
        required: 'Please enter your postcode.'
      }
    },
    messages: {
      postcode: (field: any) => 'Please enter a valid postcode.',
      buildingNameNumber: (field: string) => 'Please enter either a building name or building number.'
    }
  }
};

export default AddressValidationMessages;
